import React, { useState } from 'react';
import { Header } from './components/Header';
import { Tabs } from './components/Tabs';
import { ClinicalDatabase } from './components/ClinicalDatabase';
import { MatrixCalculator } from './components/MatrixCalculator';
import { HolographicImages } from './components/HolographicImages';
export function App() {
  const [activeTab, setActiveTab] = useState<'database' | 'matrix' | 'holographic'>('database');
  return <div className="min-h-screen bg-surface font-sans text-ink pb-16" data-id="element-1">
      <Header data-id="element-2" />
      <Tabs activeTab={activeTab} onTabChange={setActiveTab} data-id="element-3" />

      <div className="max-w-[1250px] mx-auto mt-4 md:mt-7 px-4 md:px-7" data-id="element-4">
        {activeTab === 'database' && <ClinicalDatabase data-id="element-5" />}
        {activeTab === 'matrix' && <MatrixCalculator data-id="element-6" />}
        {activeTab === 'holographic' && <HolographicImages data-id="element-7" />}
      </div>
    </div>;
}